/**
 * Restricted Visibility Checklist
 * When visibility reduced (fog, rain, etc.)
 * Regulatory: COLREGs Rule 19
 */

export const RESTRICTED_VISIBILITY_CHECKLIST = {
  id: 'restricted_visibility',
  name: 'Restricted Visibility',
  description: 'When visibility reduced (fog, rain, etc.)',
  icon: 'Eye',
  regulatory: 'COLREGs Rule 19',
  isCustomisable: true,
  items: [
    { id: 'rv_1', text: 'Radar on and operational', required: true },
    { id: 'rv_2', text: 'Safe speed for conditions', required: true },
    { id: 'rv_3', text: 'Fog signals being made', required: true },
    { id: 'rv_4', text: 'Navigation lights on', required: true },
    { id: 'rv_5', text: 'VHF Ch 16 monitored', required: true },
    { id: 'rv_6', text: 'Lookout posted', required: false },
    { id: 'rv_7', text: 'Engines ready for immediate manoeuvre', required: false }
  ]
};
